import React, { useState } from 'react'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import { footerText, HeaderText, ModuleRequestRender, statuBarSelector } from '../../functions'
import defaultAvatar from 'assets/images/default_avatar.png'
import ActionConfirmationModal from 'pages/approval-center/components/ActionConfirmationModal'

const LeaveApprovalRequest = ({ data }) => {
  // the reject and approve function is passed using state and it mutable in the children component
  const [reject, setReject] = useState(() => () => console.log('Default reject function'))
  const [approve, setApprove] = useState(() => () => console.log('Default approve function'))

  const handleReject = () => reject()
  const handleApprove = () => approve()

  // state to differentiate type of tab: pending, upcoming or responded
  const { state } = useLocation()
  const navigate = useNavigate()
  const pendingTab = state.backgroundLocation.pathname.split('/').pop() === 'pending'
  const currentTab = state.backgroundLocation.pathname.split('/').pop()

  // state of the to access the mutation function from the children
  const [mutation, setMutation] = useState(() => () => console.log('Default mutation function'))

  // state of the modal, always open. It will rendered using routing
  const [isModalOpen] = useState(true)
  const handleClose = () => {
    navigate(state.backgroundLocation)
  }

  // avatar microcomponent
  const headerAvatar = (mobile) => (
    <Box
      as="img"
      sx={{
        display: mobile ? { xs: 'block', lg: 'none' } : { xs: 'none', lg: 'block' },
        height: 50,
        width: 50,
        bgcolor: 'gray-background.main',
        objectFit: 'cover',
        borderRadius: '50%',
        border: '3px solid',
        borderColor: 'white.main',
      }}
      alt={data?.user}
      src={data?.imgUrl || defaultAvatar}
    />
  )

  // header of the modal
  const customHeader = (
    <Box display="flex" justifyContent="space-between" alignItems="center" padding={3}>
      <Box display="flex" alignItems="center" columnGap={2}>
        {headerAvatar(true)}
        <Box
          display="flex"
          alignItems={{ xs: 'flex-start', lg: 'center' }}
          columnGap={1.5}
          flexDirection={{ xs: 'column', lg: 'row' }}
          rowGap={1}
        >
          <Box
            display="flex"
            alignItems={{ xs: 'flex-start', lg: 'center' }}
            columnGap={1.5}
            flexDirection={{ xs: 'column', lg: 'row' }}
          >
            {headerAvatar(false)}
            <Typography variant="h4" fontWeight="bold" color="dark-text.main" noWrap>
              {HeaderText(data.type)}
            </Typography>
            <Icon
              sx={{
                display: { xs: 'none', lg: 'block' },
                fontSize: 7,
                color: 'alternate.main',
              }}
            >
              circle_rounded
            </Icon>
            <Typography noWrap variant="h4" fontWeight="bold" color="alternate.main">
              {data.amount} {data.amount === 1 ? 'day' : 'days'}
            </Typography>
          </Box>
          <StatusBar status={statuBarSelector(currentTab)} />
        </Box>
      </Box>
      <Box onClick={handleClose} sx={{ cursor: 'pointer' }}>
        <Icon sx={{ color: 'dark-text.main' }}>close_rounded</Icon>
      </Box>
    </Box>
  )

  const customFooter = (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'primary.light',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderRadius: '0 0 10px 10px',
      }}
    >
      <Box
        sx={{
          width: { xs: 1, lg: 'auto' },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography variant="h4">{footerText(data.type)}</Typography>
        <Typography variant="h4">
          {data?.amount} {data?.amount === 1 ? 'day' : 'days'}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
        <ActionConfirmationModal
          actionType="REJECT"
          btnText="Reject"
          actionFn={handleReject}
          mutation={mutation}
          sxButton={{ width: '150px' }}
        />
        <ActionConfirmationModal
          actionType="APPROVE"
          btnText="Approve"
          actionFn={handleApprove}
          mutation={mutation}
          sxButton={{ width: '150px' }}
        />
      </Box>
    </Box>
  )

  return (
    <AdxFormModal
      open={isModalOpen}
      handleClose={handleClose}
      disableAutoFocus
      onClose={(_, reason) => {
        if (reason !== 'backdropClick' || !pendingTab) {
          handleClose()
        }
      }}
      customHeader={customHeader}
      enableFooter={pendingTab}
      footerprops={pendingTab && customFooter}
    >
      <Box>
        {ModuleRequestRender(
          data.id,
          /*******************************/
          // type 1 : leave request
          // type 2 : leave credit request
          data.type,
          /*******************************/
          pendingTab,
          setReject,
          setApprove,
          setMutation,
          data?.requestId
        )}
      </Box>
    </AdxFormModal>
  )
}

export default LeaveApprovalRequest
